import { Shark, Utils, View } from "shark-mvc";

import templateContent from "./all-content-list.html";

import mainNavComponent from "../../components/mainNav/mainNavComponent";
import waitBoxComponent from "../../components/waitBox/waitBoxComponent";
import imageContentManager from "../../controllers/imageContentManager";
import placeContentManager from "../../controllers/placeContentManager";
import textContentManager from "../../controllers/textContentManager";
import ImageContent from "../../models/ImageContent";
import PlaceContent from "../../models/PlaceContent";
import TextContent from "../../models/TextContent";
import imageContentView from "../imageContent/imageContentView";
import placeContentView from "../placeContent/placeContentView";
import textContentView from "../textContent/textContentView";

class AllContentListView extends View {
	recentRange = {
		first: 0,
		length: 5000,
	};

	recentSort = {
		updated_at: "DESC",
	};

	constructor () {
		super("allContentListView");
		this.setTemplate(templateContent);
	}

	afterLoad () {
		this.filterImageContent();
		this.filterPlaceContent();
		this.filterTextContent();

		this.sortTextContent();
		this.sortImageContent();
	}

	beforeLoad () {
		Shark.set({
			tagGroupLabels: {
				"27b845": "Alidays",
				"ba7c52": "Dave",
			},
		});
		// this.refreshList();
	}

	deduplicateList (contentList) {
		const outputList = [];
		let lastContent;
		contentList.forEach(item => {
			if (lastContent?.guid !== item.guid) {
				item.customTags = [];

				if (item?.contentCustomTags?.tags) {
					item.customTags.push({ tags:JSON.parse(item?.contentCustomTags?.tags), title: Shark.$store.tagGroupLabels[item.contentCustomTags.categoryGuid.slice(0, 6)]});
				}

				outputList.push(item);
				lastContent = item;
			}
			else {
				if (item?.contentCustomTags?.tags) {
					lastContent.customTags.push({ tags:JSON.parse(item?.contentCustomTags?.tags), title: Shark.$store.tagGroupLabels[item.contentCustomTags.categoryGuid.slice(0, 6)]});
				}
				// lastContent.customTags.push(item?.contentCustomTags?.tags ? { tags:JSON.parse(item?.contentCustomTags?.tags), title: Shark.$store.tagGroupLabels[item.contentCustomTags.categoryGuid.slice(0, 6)]} : {tag: [], title: ""});
			}
		});

		return outputList;
	}

	editContent (contentGuid, type) {
		waitBoxComponent.open();

		let destView;
		let listToSearch;

		switch (type) {
			case "image":
				destView = imageContentView;
				listToSearch = Shark.$store.allImageContentList;
				break;
			case "place":
				destView = placeContentView;
				listToSearch = Shark.$store.allPlaceContentList;
				break;
			case "text":
				destView = textContentView;
				listToSearch = Shark.$store.allTextContentList;
				break;
		}

		const currContent = Utils.safp(listToSearch, "guid", contentGuid);

		if (currContent) {
			Shark.set({
				currContent,
				editContentGoBackPage: allContentListView,
			});

			Shark.openPage(destView, {urlSearchParams: { coguid: currContent.guid } });
		}
	}

	editContentBtn_clickHandler (event, data) {
		if (data.guid) {
			this.editContent(data.guid, data.type);
		}
	}

	filterImageContent () {
		const { allContentListViewFilters, allImageContentList } = Shark.get();

		if (allImageContentList) {
			let filteredAllImageContentList = allImageContentList.filter(item => {
				// const hasCustomTags = item.customTags.length === 0;
				// const needsReview = item.extraData.needReview;
			
				// const showToTagImages = allContentListViewFilters.showToTagImages;
				// const showNeedReviewImages = allContentListViewFilters.showNeedReviewImages;

				// if ((showToTagImages && hasCustomTags) || (showNeedReviewImages && needsReview)) {
				// 	return true;
				// }
			
				// if (!showToTagImages && !showNeedReviewImages) {
				// 	return true;
				// }
			
				// return false;

				if (allContentListViewFilters.showToTagImages) {
					if (item.customTags.length === 0) {
						if (allContentListViewFilters.showNeedReviewImages)
						{
							if (item.extraData.needReview) {
								return true;
							}
							return false;
						}
						return true;
					}
					return false;
				}
				else if (allContentListViewFilters.showNeedReviewImages) {
					if (item.extraData.needReview) {
						return true;
					}
					return false;
				}
				else {
					return true;
				}
				// return (allContentListViewFilters.showToTagImages && item.customTags.length === 0) && (allContentListViewFilters.showNeedReviewImages && item.extraData.needReview)
				// return allContentListViewFilters.showToTagImages || item.customTags.length === 0;
			});
			
			//sorting by reference volume
			const referenceVolumeFieldValue = allContentListViewFilters.referenceVolume;
			if ( referenceVolumeFieldValue != "" ) {
				filteredAllImageContentList = filteredAllImageContentList.filter(item => item.referenceVolumes.some(volume => volume.value.includes(referenceVolumeFieldValue)));
			}
			
			// Dave: no sort di default, usiamo l'apposita funzione
			//sorting by date 
			// filteredAllImageContentList.sort((a, b) => b.updatedAt - a.updatedAt);
			
			Shark.set({
				filteredAllImageContentList,
			});
		}
	}

	filterTextContent () {
		const { allTextContentList } = Shark.get();
		let { allContentListViewFilters } = Shark.get();

		if (allTextContentList) {
			let filteredAllTextContentList = allTextContentList.filter(item => {
				return (allContentListViewFilters.showTaggedText || item.customTags.length === 0) && ((allContentListViewFilters.showNeedReviewText && item.extraData.needReview) || !allContentListViewFilters.showNeedReviewText);
			});
			
			//sorting by reference volume
			const referenceVolumeFieldValue = document.getElementById("referenceVolumeField").value;
			if ( referenceVolumeFieldValue != "" ) {
				filteredAllTextContentList = filteredAllTextContentList.filter(item => item.referenceVolumes.some(volume => volume.value.includes(referenceVolumeFieldValue)));
			}

			Shark.set({
				filteredAllTextContentList,
			});
		}
	}

	filterPlaceContent () {
		const { allContentListViewFilters, allPlaceContentList } = Shark.get();

		if (allPlaceContentList) {
			let filteredAllPlaceContentList = allPlaceContentList;

			if (!allContentListViewFilters.showPlacesWithHierarchy) {
				filteredAllPlaceContentList = allPlaceContentList.filter(item => item.hierarchy.length === 0);
			}

			//sorting by reference volume
			const referenceVolumeFieldValue = document.getElementById("referenceVolumeField").value;

			if (referenceVolumeFieldValue !== "") {
				filteredAllPlaceContentList = allPlaceContentList.filter(item => item.referenceVolumes.some(volume => volume.value.includes(referenceVolumeFieldValue)));
				
				Shark.set({
					filteredAllPlaceContentList,
				});
			}
			else {
				Shark.set({
					filteredAllPlaceContentList,
				});
			}
		}
	}

	init () {
		this.addComponents([mainNavComponent, waitBoxComponent]);

		const allContentListViewFiltersRawData = localStorage.allContentListViewFilters;
		let allContentListViewFiltersData;

		if (allContentListViewFiltersRawData) {
			allContentListViewFiltersData = JSON.parse(allContentListViewFiltersRawData);
		}
		
		const allContentListViewFilters = Shark.getInstance("__smart__", {
			referenceVolume: "",
			showToTagImages: allContentListViewFiltersData ? allContentListViewFiltersData.showToTagImages : true,
			showNeedReviewImages: allContentListViewFiltersData ? allContentListViewFiltersData.showNeedReviewImages : true,
			showNeedReviewText: allContentListViewFiltersData ? allContentListViewFiltersData.showNeedReviewText : true,
			showPlacesWithHierarchy: allContentListViewFiltersData ? allContentListViewFiltersData.showPlacesWithHierarchy : true,
			showTaggedText: allContentListViewFiltersData ? allContentListViewFiltersData.showTaggedText : true,
			sortAllContentByPage: allContentListViewFiltersData ? allContentListViewFiltersData.sortAllContentByPage : true,
			onDataChanged: data => {
				localStorage.allContentListViewFilters = JSON.stringify(allContentListViewFilters);
				console.log("allContentListViewFilters -- onDataChanged", data);
				if (data.property === "showToTagImages" || data.property === "showNeedReviewImages") {
					this.filterImageContent();
				}
				else if (data.property === "showPlacesWithHierarchy") {
					this.filterPlaceContent();
				}
				else if (data.property === "showTaggedText") {
					this.filterTextContent();
				}
				else if (data.property === "sortAllContentByPage") {
					console.log("Sort by tag");
					this.sortImageContent();
					this.sortTextContent();
				}
			}
		});

		Shark.set({
			allContentListViewFilters,
		});
	}

	refreshList () {
		this.refreshImageContentList();
		this.refreshPlaceContentList();
		this.refreshTextContentList();
	}

	refreshListBtn_clickHandler () {
		this.refreshList();
	}

	refreshImageListBtn_clickHandler () {
		this.refreshImageContentList();
	}

	refreshPlaceListBtn_clickHandler () {
		this.refreshPlaceContentList();
	}

	refreshTextListBtn_clickHandler () {
		this.refreshTextContentList();
	}

	refreshImageContentList () {
		waitBoxComponent.open();

		const { allContentListViewFilters } = Shark.get();

		const filters = {
			referenceVolume: allContentListViewFilters.referenceVolume,
		};
	
		imageContentManager.getRichList({ filters, options: { includeTags: true}, range: this.recentRange, sort: this.recentSort })
		.then(response => {
			const imageContentList = Shark.getInstanceList(ImageContent, response.data);
			Shark.set({
				allImageContentList: this.deduplicateList(imageContentList),
			});
			this.filterImageContent();
			this.sortImageContent();

			waitBoxComponent.close();
		});
	}

	refreshPlaceContentList () {
		waitBoxComponent.open();

		placeContentManager.getList({ options: { includeTags: true}, range: this.recentRange, sort: this.recentSort })
		.then(response => {
			const placeContentList = Shark.getInstanceList(PlaceContent, response.data);
			Shark.set({
				allPlaceContentList: placeContentList,
			});
			this.filterPlaceContent();

			waitBoxComponent.close();
		});
	}

	refreshTextContentList () {
		waitBoxComponent.open();

		const { allContentListViewFilters } = Shark.get();

		const filters = {
			referenceVolume: allContentListViewFilters.referenceVolume,
		};

		textContentManager.getRichList({ filters, options: { includeTags: true}, range: this.recentRange, sort: this.recentSort })
		.then(response => {
			const textContentList = Shark.getInstanceList(TextContent, response.data);
			Shark.set({
				allTextContentList: this.deduplicateList(textContentList),
			});
			this.filterTextContent();
			this.sortTextContent();

			waitBoxComponent.close();
		});
	}

	sortImageContent () {
		const { filteredAllImageContentList, allContentListViewFilters} = Shark.get();

		if (filteredAllImageContentList) {
			if (allContentListViewFilters.sortAllContentByPage) {
				filteredAllImageContentList.sort((a, b) => {
					return this.sortTagsByPage(a, b);
				});

				Shark.set({
					filteredAllImageContentList,
				});
			}
		}
	}

	sortTagsByPage (a, b) {
		// console.log("a", a);
		// console.log("a tags", a.tags);
		const tagA = a.tags.find(tag => tag.value.includes("pag"));
		const tagB = b.tags.find(tag => tag.value.includes("pag"));
		// console.log("tagA", tagA);

		if (tagA && tagB) {
			const regex = /pag(\d+)/; // looks for the string "pag" followed by one or more digits in the input text. It captures the numeric part (the digits) of the "pagXXX" format
			const aMatch = tagA.value.match(regex);
			const bMatch = tagB.value.match(regex);
			if (aMatch && bMatch) {
				// Extract the numeric part of the tag and convert it to a number
				const aNumber = parseInt(aMatch[1]);
				const bNumber = parseInt(bMatch[1]);
			
				// Compare the numeric parts of the tags
				if (aNumber < bNumber) {
					return -1;
				} else if (aNumber > bNumber) {
					return 1;
				} else {
					return 0;
				}
			} 
			else {
				// If either tag doesn't match the pattern, place it at the end
				return aMatch ? -1 : bMatch ? 1 : 0;
			}
		}
		else {
			// If either tag doesn't exists
			return tagA ? -1 : tagB ? 1 : 0;
		}
	}

	sortTextContent () {
		const { filteredAllTextContentList, allContentListViewFilters} = Shark.get();

		if (filteredAllTextContentList) {
			if (allContentListViewFilters.sortAllContentByPage) {
				filteredAllTextContentList.sort((a, b) => {
					return this.sortTagsByPage(a, b);
				});

				Shark.set({
					filteredAllTextContentList,
				});
			}
		}
	}

	updateImagePermissionsBtn_clickHandler () {
		const { filteredAllImageContentList } = Shark.get();

		if (filteredAllImageContentList && confirm("Vuoi davvero proseguire? Lo sai quello che stia per fare??")) {
			const imageToProcessCount = filteredAllImageContentList.filter(item => item.extraData.permissionsAutoSet === undefined).length;

			if (confirm(`Ma davvero davvero? Questo potrebbe essere un task molto pesante per il sistema! Verranno processate ${imageToProcessCount} immagini!!!`)) {
				this.upadateImagePermissions();
			}
		}
	}

	async upadateImagePermissions () {
		const { filteredAllImageContentList } = Shark.get();

		if (filteredAllImageContentList) {
			waitBoxComponent.open();

			for (let i = 0; i < filteredAllImageContentList.length; i++) {
				let item = filteredAllImageContentList[i];

				if (item.extraData.permissionsAutoSet === undefined) {// || item.extraData.permissionsAutoSet === true) {
					imageContentManager.extractAndSetImagePermissionsFromSource(item);

					await imageContentManager.save(item);
					await this.sleep(500);
				}
			}
			
			console.log({filteredAllImageContentList, sources: new Set(filteredAllImageContentList.map(item => item.source))});

			waitBoxComponent.close();
		}
	}

	async sleep (duration) {
		return new Promise(resolve => {
			setTimeout(() => {
				resolve(true);
			}, duration);
		});
	}
	
}

const allContentListView = new AllContentListView();

Shark.registerView(allContentListView);

export default allContentListView;